import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
// @ts-ignore
import Loader from 'react-loader-spinner'
import React from "react";

export function LoaderComponent(props: {height?: number, width?: number, color?: string}) {
  return <Loader type="Rings" color={props.color ?? "#3C4B64"} height={props.width ?? 200} width={props.height ?? 200} />
  
  
}